<!-- views/HomeView.vue -->
<template>
  <Wrapper>
    <el-row :gutter="20" class="dashboard-container">
      
      <!-- 第一行：世界时钟（全宽） -->
      <el-col :span="24">
        <WorldClocks />
      </el-col>

      <!-- 第二行：价格信息（全宽） -->
      <el-col :span="24">
        <MarketPrices />
      </el-col>

      <!-- 以下板块暂时隐藏（v1.3 调试阶段，后续功能开发完成后再放开） -->
      <!-- 
      <el-col :span="24"><CultureSection /></el-col>
      <el-col :span="24"><IndustryNews /></el-col>
      <el-col :span="24"><QuickLinks /></el-col>
      <el-col :span="24"><StatsReportSection /></el-col>
      -->

    </el-row>
  </Wrapper>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Wrapper from '@/components/Wrapper.vue'

// 各板块组件导入（仅保留当前需要的两个）
import WorldClocks from '@/components/dashboard/WorldClocks.vue'
import MarketPrices from '@/components/dashboard/MarketPrices.vue'

const authStore = useAuthStore()

onMounted(() => {
  console.log('[HomeView] ===== 首页加载开始 =====')
  console.log('[HomeView] 当前路由:', window.location.pathname)
  console.log('[HomeView] 当前用户状态:', authStore.currentUser ? '已登录' : '未登录')
  
  // 严格遵守 Auth 规范：确保 fetchCurrentUser 被调用
  if (!authStore.currentUser) {
    console.log('[HomeView] 触发 fetchCurrentUser')
    authStore.fetchCurrentUser()
  } else {
    console.log('[HomeView] 当前用户已存在:', authStore.currentUser?.username || authStore.currentUser?.email)
    console.log('[HomeView] 角色徽章信息:', authStore.roleBadge)
  }
  
  console.log('[HomeView] 当前仅显示世界时钟 + 价格信息板块（其他板块已临时隐藏）')
  console.log('[HomeView] ===== 首页加载完成 =====')
})

onBeforeUnmount(() => {
  console.log('[HomeView] 首页组件即将卸载')
})

</script>

<style scoped>
.dashboard-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 120px); /* 适配 Wrapper 的 Header + Footer */
}

.el-col {
  margin-bottom: 20px;
}

/* 调试阶段临时高亮边框，便于观察各板块是否真正独占一行 */
.el-col > div {
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  transition: all 0.3s;
}

.el-col > div:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>